import { RequestDto } from '@oncolens/oncolens-ui/lib/dto/event/request';
import { useQuery } from 'react-query';
import api from '@/utils/httpClient';
import { FullCollaborationRequestDto } from '../dto/FullCollaborationRequest';

export const getRequest = (id: string) => {
  return api
    .get(`/api/collaborationrequests/${id}`)
    .then((response) => response.data as RequestDto);
};

export const useGetRequest = (requestId: string) => {
  return useQuery(['request', requestId], () => getRequest(requestId));
};

export const getFullRequest = (id: string) => {
  return api
    .get(`/api/collaborationrequests/full-collaboration-request/${id}`)
    .then((response) => response.data as FullCollaborationRequestDto);
};

export const useGetFullRequest = (requestId: string) => {
  return useQuery(['request-full', requestId], () => getFullRequest(requestId));
};
